import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { print } from 'graphql';
import { ListCategoryData } from '../models/shop';
import { GET_CATEGORIES_BY_ID } from '../utils/queries';
import request from '../utils/request';
import { RootState } from '../utils/store';
import { signOut } from './user';

export const getCategoryById = createAsyncThunk(
  'category/getCategoryById',
  async (category_ids: string[], { rejectWithValue }) => {
    try {
      const { data } = await request.get('graphql', {
        params: {
          query: print(GET_CATEGORIES_BY_ID),
          variables: {
            id: category_ids,
          },
        },
      });
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error?.response?.data);
    }
  }
);


interface GetCategoryById {
    dataCategories: null | ListCategoryData;
    loadingListCategories: boolean;
}


const initialState:GetCategoryById = {
    dataCategories:null,
    loadingListCategories : false,
};

const categorySlice = createSlice({
  name: 'category',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryById.pending, (state, action) => {
        state.loadingListCategories = true;
      })
      .addCase(getCategoryById.fulfilled, (state, action) => {
        state.loadingListCategories = false;
        state.dataCategories = action.payload.data.categories;
      })
      .addCase(signOut, () => ({ ...initialState }));
  },
});

export const selectCategoryDetail = (state: RootState) => state.category.dataCategories;
export const loadingCategoryDetail = (state: RootState) =>
  state.category.loadingListCategories;

export default categorySlice.reducer;
